import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-manage-receipts',
  templateUrl: './manage-receipts.component.html',
  styleUrls: ['./manage-receipts.component.css']
})
export class ManageReceiptsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
